import { UserAction,ADD_FIRSTNAME,ADD_LASTNAME,ADD_ID,ADD_ROL} from "./types";

export function addFirstName(firstname: string): UserAction {
    return {
        type: ADD_FIRSTNAME,
        payload: firstname
    }
  }
  export function addLastName(lastname: string): UserAction {
    return {
        type: ADD_LASTNAME,
        payload: lastname
    }
  }
  export function addId(id: string): UserAction {
    return {
        type: ADD_ID,
        payload: id
    }
  }
  export function addRol(rol: string): UserAction {
    return {
        type: ADD_ROL,
        payload: rol
    }
  }